import { ALARM_ID_DECIMAL, ALARM_ID_HEXADECIMAL } from '../../common/constants';
import { System } from '../../rtk/availableSystemApi';

export type Credentials = {
  username: string;
  encodedPassword: string;
};

export type Error = {
  errorMessage: string;
};

export enum UserRolesType {
  User = 'User',
  Engineer = 'Engineer',
  Admin = 'Admin',
}

export type UserDetailsInitialState = {
  isLoggedIn: boolean;
  userRoles: UserRolesType[];
  unitPreference: string;
  dateFormatPreference: string;
  alarmIdRepresentation: typeof ALARM_ID_HEXADECIMAL | typeof ALARM_ID_DECIMAL;
  preferredSystems: System[];
};
